import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Forgot Password Api Service
 */
const ForgotPasswordApiService = {
  // Forgot Password
  forgotPassword: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_FORGOT_PASSWORD, data)
    } catch (err) {
      DebugService.error('Forgot Password Api Service: Caught error while forgot password', err, data)
    }
  },

  // Reset Password
  resetPassword: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_RESET_PASSWORD, data)
    } catch (err) {
      DebugService.error('Forgot Password Api Service: Caught error while reset password', err, data)
    }
  },
};

export default ForgotPasswordApiService;
